import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {LorenFeatureToggleService} from '../../services/loren-feature-toggle-service/loren-feature-toggle.service';
import {LorenFeature} from '../../enums/loren-feature.enum';

@Injectable({
    providedIn: 'root'
})
export class LorenDashboardFeatureToggleGuard  {
    protected lorenFeatureToggleService = inject(LorenFeatureToggleService);


    canActivate(): Observable<boolean> {
        return  this.lorenFeatureToggleService.userHasFeature(LorenFeature.GENERIC_DASHBOARD);
    }
}
